import React from 'react';
import { useSearchBarContext } from '../../Context/SearchBarContext';
import { SearchIcon } from '@fmlx/icons';
import { ESearchBarMode, RecentSearchResult } from '../../Context/types';
import { SearchDetailDTO } from 'business/models/Models';

const hasAdvancedSearchDetails = (searchDetail?: SearchDetailDTO) =>
  Boolean(
    searchDetail?.fileName ||
      searchDetail?.ownerId != null ||
      searchDetail?.dateFrom ||
      searchDetail?.dateTo ||
      searchDetail?.locationTreeNodeIds?.length > 0,
  );

export const RecentSearches = () => {
  const { recentResults, updateFilters, setMode, setIsPanelOpen } = useSearchBarContext();

  const handleRecentSearchClick = (recentSearch: RecentSearchResult) => {
    const { searchDetail } = recentSearch;
    if (!searchDetail) {
      return;
    }
    const isAdvanced = hasAdvancedSearchDetails(searchDetail);
    if (isAdvanced) {
      setMode(ESearchBarMode.Advanced);
    }
    updateFilters({
      query: searchDetail.searchQuery ?? '',
      fileName: searchDetail.fileName ?? '',
      ownerId: searchDetail.ownerId ?? null,
      targetTypes: searchDetail.searchTarget ?? [],
      dateRange: { from: searchDetail.dateFrom ?? null, to: searchDetail.dateTo ?? null },
      locationTreeNodeIds: searchDetail.locationTreeNodeIds ?? [],
    });
    if (isAdvanced) {
      setIsPanelOpen(true);
    }
  };

  return (
    <div id="recent-searches-wrapper" className="flex flex-col">
      {recentResults?.length > 0 ? (
        recentResults.map((res, idx) => {
          const name =
            res.searchDetail?.fileName?.length > 0
              ? res.searchDetail.fileName
              : res.searchDetail.searchQuery;
          return (
            <div
              key={idx}
              id={`recent-searches-item-${idx}`}
              className="rounded-sm p-2 hover:bg-[#f5f5f5] flex flex-1 flex-row w-full gap-2 items-center"
              onClick={(e) => {
                e.stopPropagation();
                handleRecentSearchClick(res);
              }}
            >
              <SearchIcon customSize={18} customColor="#414141" />
              <div>{name}</div>
            </div>
          );
        })
      ) : (
        <div
          id="recent-searches-empty"
          className="w-full text-center font-[Roboto] text-[#888888] text-sm"
        >
          No recent search
        </div>
      )}
    </div>
  );
};
